/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Zdroj výjimek představující chybové hlášení ve starém Sentry Raven API.
 * K výjimce se přidávají další dodatečné informace.
 * @deprecated Tento starý formát se již nepoužívá.
 * Ponecháno pouze pro umožnění smazání dříve zálohovaných výjimek.
 */
const ExceptionResource = {
  name: 'exception'
};

export default ExceptionResource;
